import { createContext, useContext } from "react";
import type { User } from "firebase/auth";

export interface UserProfile {
  email: string;
  user_id: string;
  role: "admin" | "user";
}

export type AuthState =
  | { status: "idle" }
  | { status: "verifying"; user: User }
  | { status: "allowed"; user: User; profile: UserProfile }
  | { status: "denied"; reason: string };

export interface AuthContextValue {
  state: AuthState;
  signOut: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext);
  if (!context) throw new Error("useAuth must be inside <AuthProvider>");
  return context;
}
